import { ArrayDataSource } from './BaseDataSources';
import { IPriceType } from '../Interfaces';

export class PriceTypeSource extends ArrayDataSource<IPriceType> {
  public constructor() {
    super('/datasource/pricetypes');
  }
}